const COLORS = Object.freeze({
  DARK_INDIGO: "#231476",
  DEEP_LILAC: "#857bb8",
  GREYISH_BROWN: "#473e2e",
  BROWN_GREY: "#8c8c8c",
  PALE_GREY: "#fafafc",
  LIGHT_PERIWINKLE: '#d4d0e6',
});

export default COLORS;